import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full bg-white border-b border-gray-100 shadow-sm sticky top-0 z-50" }
const _hoisted_2 = { class: "max-w-screen-4xl mx-auto flex items-stretch overflow-hidden h-16 lg:h-24" }
const _hoisted_3 = { class: "flex items-center space-x-2" }
const _hoisted_4 = { class: "hidden lg:block text-[10px] font-bold uppercase tracking-wider" }
const _hoisted_5 = { class: "flex-1 flex items-stretch bg-gray-100 gap-px overflow-x-auto no-scrollbar" }
const _hoisted_6 = { class: "flex w-full items-center space-x-2 lg:space-x-4 pl-4" }
const _hoisted_7 = { class: "flex flex-col min-w-0 grow" }
const _hoisted_8 = { class: "text-[9px] lg:text-[11px] font-bold uppercase tracking-wider truncate text-gray-400 group-hover:text-gray-600" }
const _hoisted_9 = { class: "text-[10px] lg:text-[12px] font-medium truncate text-brand-main" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex w-full items-center space-x-2 lg:space-x-4 pl-4" }
const _hoisted_12 = {
  key: 0,
  class: "relative w-full"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "text-xs font-bold"
}
const _hoisted_16 = { class: "flex flex-col min-w-0 grow" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-xl font-ivymode mb-4 text-gray-900" }
const _hoisted_19 = { class: "text-gray-600 mb-8 font-light italic" }
const _hoisted_20 = { class: "space-y-3" }

import {computed, ref} from "vue";
import {useStore} from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2ItemWidget',
  props: {
  session: {
    type: Object,
    required: true
  }
},
  emits: ['show-step-widget', 'delete-item'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore();
const emit = __emit;

const items = computed(() => props.session?.items || []);
const itemIdx = computed(() => store.getters["session/getItemIdx"]);

const showDeleteModal = ref(false);
const itemIdxToDelete = ref<number | null>(null);

const confirmDelete = (idx: number) => {
  itemIdxToDelete.value = idx;
  showDeleteModal.value = true;
};

const onConfirmDelete = () => {
  if (itemIdxToDelete.value !== null) {
    emit('delete-item', itemIdxToDelete.value);
    showDeleteModal.value = false;
    itemIdxToDelete.value = null;
  }
};

const totalSetPrice = computed(() => {
  return items.value.reduce((acc: number, item: any) => acc + (item.price?.total || 0), 0);
});

const getItemType = (item: any) => {
  const part = item.desc?.parts?.find((p: any) => p.parameter === 'item_type');
  return part ? part.value : '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('show-step-widget'))),
        class: "flex flex-col justify-center px-4 lg:px-8 border-r border-gray-100 cursor-pointer hover:bg-gray-50 transition-colors bg-gray-100 lg:bg-white z-20"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "currentColor",
            class: "w-6 h-6"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
            })
          ], -1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.title')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "flex-1 flex items-center justify-center px-2 lg:px-6 relative group transition-all duration-300 step-container cursor-pointer min-w-[140px] lg:min-w-[200px]",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(store).commit('session/setViewMode', 'set'); _unref(store).commit('session/setItemIdx', 0)})
        }, [
          _createElementVNode("div", _hoisted_6, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-10 h-auto lg:w-14 lg:h-14 aspect-square rounded-full flex items-center justify-center border-2 transition-all duration-300 overflow-hidden bg-white border-gray-200 group-hover:border-gray-300" }, [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                class: "w-4 h-auto lg:w-8 lg:h-8 text-gray-400 group-hover:text-gray-600"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('components.itemV2.itemV2Main.complete_your_look')), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$n(totalSetPrice.value, 'currency')), 1)
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.item_number || idx,
            class: _normalizeClass(["flex-1 flex items-center justify-center px-2 lg:px-6 relative group transition-all duration-300 step-container cursor-pointer min-w-[140px] lg:min-w-[200px]", {'active': itemIdx.value === idx}]),
            onClick: ($event: any) => {_unref(store).commit('session/setViewMode', 'item'); _unref(store).commit('session/setItemIdx', idx)}
          }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["w-12 h-auto lg:w-14 lg:h-14 rounded-full flex items-center justify-center border-2 transition-all duration-300 overflow-hidden bg-white", [itemIdx.value === idx ? 'border-white' : 'border-gray-200 group-hover:border-gray-300']])
              }, [
                (item.image?.filename)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      (item.image.filename_layer)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: item.image.filename_layer,
                            class: "absolute insert-0 w-full h-full aspect-square object-cover",
                            alt: ""
                          }, null, 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", {
                        src: item.image.filename,
                        class: "w-full h-full object-cover",
                        alt: ""
                      }, null, 8, _hoisted_14)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(idx + 1), 1))
              ], 2),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", {
                  class: _normalizeClass(["text-[9px] lg:text-[11px] font-bold uppercase tracking-wider truncate transition-colors", itemIdx.value === idx ? 'text-black' : 'text-gray-400 group-hover:text-gray-600'])
                }, _toDisplayString(getItemType(item)), 3),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-[10px] lg:text-[12px] font-medium truncate", itemIdx.value === idx ? 'text-black' : 'text-brand-main'])
                }, _toDisplayString(_ctx.$n(item.price.total, 'currency')), 3),
                _createElementVNode("button", {
                  onClick: _withModifiers(($event: any) => (confirmDelete(idx)), ["stop"]),
                  class: "text-[9px] lg:text-[10px] text-brand-main hover:text-black mt-1 uppercase font-bold text-left transition-colors"
                }, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.remove')), 9, _hoisted_17)
              ])
            ])
          ], 10, _hoisted_10))
        }), 128))
      ])
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showDeleteModal.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[100] flex items-center justify-center bg-black/30 backdrop-blur-sm px-4",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showDeleteModal.value = false))
            }, [
              _createElementVNode("div", {
                class: "bg-white p-8 max-w-sm w-full shadow-2xl border border-gray-100",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, [
                _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.remove_confirm_title')), 1),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.remove_confirm_text')), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    onClick: onConfirmDelete,
                    class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light transition-colors"
                  }, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.confirm')), 1),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (showDeleteModal.value = false)),
                    class: "block w-full text-brand-main bg-white p-2 text-center hover:bg-brand-gray border border-brand-main text-sm font-light transition-colors"
                  }, _toDisplayString(_ctx.$t('components.itemV2.itemV2ItemWidget.cancel')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})